import React, { useEffect, useRef } from 'react';
import { ReactComponent as Close } from '../assets/closeBtn.svg';
import { ReactComponent as ReadIcon } from '../assets/closeBtn.svg';
import { ReactComponent as DeleteIcon } from '../assets/deleteIcon.svg';
import { ReactComponent as Arrow } from '../assets/arr-not.svg';

const NotificationsModal = ({ notifications, onClose, onMarkAsRead, onDelete, onMarkAllAsRead, onNavigate }) => {
    const hasUnread = notifications.some(notification => !notification.read);
    const modalRef = useRef(null);

    // Обработка клика вне модального окна
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        // Обработка нажатия клавиши Esc
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscKey);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [onClose]);

    // Обработчик клика по уведомлению
    const handleNotificationClick = (notification) => {
        // Если есть метаданные для навигации и функция навигации
        if (notification.metadata && onNavigate) {
            console.log('Метаданные для навигации:', notification.metadata);

            // Отмечаем уведомление как прочитанное
            if (!notification.read) {
                onMarkAsRead(notification._id);
            }

            // Вызываем функцию навигации с метаданными
            onNavigate(notification.metadata);
        } else {
            console.log('Нет метаданных для навигации или функции onNavigate');
        }
    };

    return (
        <div className="notifications-modal-overlay">
            <div className="notifications-modal" ref={modalRef}>
                <div className="notifications-header">
                    <div className="title-container">
                        <Arrow className="arrow-icon" />
                        <h3>Новые уведомления</h3>
                        <Arrow className="arrow-icon left" />
                    </div>
                    <button className="close-button" onClick={onClose}>
                        <Close />
                    </button>
                </div>

                <div className="notifications-list">
                    {notifications.length === 0 ? (
                        <div className="empty-notifications">Уведомлений нет</div>
                    ) : (
                        notifications.map(notification => (
                            <div
                                key={notification._id}
                                className={`notification-item ${notification.read ? 'read' : 'unread'} ${notification.metadata ? 'clickable' : ''}`}
                            >
                                <div
                                    className="notification-content"
                                    onClick={() => handleNotificationClick(notification)}
                                >
                                    <div className="notification-title">{notification.title}</div>
                                    <div className="notification-message">{notification.message}</div>
                                    <div className="notification-date">
                                        {notification.read
                                            ? "Прочтено"
                                            : new Date(notification.createdAt).toLocaleDateString('ru-RU')
                                        }
                                    </div>
                                </div>
                                <div className="notification-actions" onClick={(e) => e.stopPropagation()}>
                                    <button
                                        className="action-button delete-button"
                                        onClick={() => onDelete(notification._id)}
                                        title="Удалить"
                                    >
                                        <DeleteIcon />
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {hasUnread && (
                    <div className="notifications-footer">
                        <button className="mark-all-read-button" onClick={onMarkAllAsRead}>
                            Отметить прочитанным
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationsModal; 